<template>
  <b-alert show variant="warning" class="mt-2">
    <h4>
      <b-icon icon="credit-card" />
      {{ $t('user.payment.paymentLeadPreferences.title') }}
    </h4>
    <b-form action="#">
      <b-form-group
        required
        stacked
        :label="$t('user.payment.paymentLeadPreferences.description')"
      >
        <b-form-radio
          v-for="(preferences, index) in paymentPreferences"
          :key="index"
          name="payment"
          :value="preferences.value"
          v-model="paymentPreference"
          @change="emitChange()"
          >{{ preferences.description }}
          <b-badge
            v-if="
              getAdditionalProvisionFee(
                provisionPercent,
                preferences.commission,
              ) > 0 && preferences.value === paymentPreference
            "
            :key="`badge${index}`"
          >
            {{
              $t('user.payment.paymentLeadPreferences.payment_fee_label', {
                fee: $options.filters.decimalSingle(
                  getAdditionalProvisionFee(
                    provisionPercent,
                    preferences.commission,
                  ),
                ),
              })
            }}</b-badge
          ></b-form-radio
        >
      </b-form-group>
    </b-form>
  </b-alert>
</template>
<script>
export default {
  props: {
    provisionPercent: {
      default: 0,
      type: Number,
    },
    currentStatus: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      paymentPreference: 'today',
      paymentPreferences: [
        {
          description: this.$t(
            'user.payment.paymentLeadPreferences.preferences.today',
          ),
          value: 'today',
          commission: 0,
        },
        {
          description: this.$t(
            'user.payment.paymentLeadPreferences.preferences.one_month',
          ),
          value: 'extendOneMonth',
          commission: 1.1,
        },
        {
          description: this.$t(
            'user.payment.paymentLeadPreferences.preferences.three_months',
          ),
          value: 'extendThreeMonths',
          commission: 1.2,
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    emitChange() {
      this.$emit('updatePaymentPreferences', this.paymentPreference);
    },
    getAdditionalProvisionFee(provisionPercent, commission) {
      return provisionPercent * commission - provisionPercent;
    },
  },
};
</script>
